module.exports = __webpack_public_path__ + "static/media/icons8-java.a5f2db70.svg";